import React, { PropsWithChildren, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { DialogContentContainer } from '../../../../pcr-selector/styled';
import { PCRModel } from 'services/EpdClient';
import CPcrSelectorDialogForm from './CPcrSelectorDialogForm';
import { PrimaryButton, SecondaryButton } from 'components/v2/buttons';
import { HelpBox } from 'components/v2/help-boxes';

type TProps = PropsWithChildren<{
  visible: boolean;
  onHide(): void;
  initialCpcr: PCRModel | undefined;
  onCpcrChange(cpcr: PCRModel): void;
  cpcrList: PCRModel[];
}>;

const CPcrSelectorDialog = ({ visible, onHide, initialCpcr, onCpcrChange, cpcrList }: TProps) => {
  const formRef = useRef<React.ElementRef<typeof CPcrSelectorDialogForm>>(null);

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header="Add Complementary Product Category Rule (C-PCR)"
      contentStyle={cpcrList?.length > 0 ? {} : { overflowY: 'initial' }}
      resizable={false}
      style={{ width: '35rem' }}
      footer={
        <>
          <SecondaryButton label="Cancel" onClick={onHide} outlined />
          <PrimaryButton
            label="Add"
            onClick={() => {
              const cpcr = formRef.current?.getSelectedValue();
              onHide();
              if (cpcr) {
                onCpcrChange(cpcr);
              }
            }}
            autoFocus
          />
        </>
      }
    >
      <DialogContentContainer>
        <HelpBox style={{ marginBottom: '1rem' }}>
          Please make your selection from the available c-PCRs below. In order to create an EPD based on other c-PCRs that
          are not supported by EPD Compiler, please use the Standard EPD format.
        </HelpBox>
        <CPcrSelectorDialogForm ref={formRef} initialCpcr={initialCpcr} cpcrList={cpcrList} />
      </DialogContentContainer>
    </Dialog>
  );
};

export default CPcrSelectorDialog;
